import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    beneDetails: {
      margin: '0 0 40px 0',
    },
    editButton: {
      color: '#CF752F',
      padding: '8.5px'
    },
  }),
  { name: 'Details' },
);
